import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";

import {TaskAction} from "./TaskAction";
import {TaskTimeType} from "./TaskTimeType";
import {RewardModel} from "../../reward/RewardModel";
import {Currency} from "../../currency/Currency";
import {Schema} from "@/common/Schema";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export class TaskModel extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && v.valid() ? serialize(TaskModel, v) : SKIP;
            },
            (v) => {
                return deserialize(TaskModel, v);
            }
        );
    }

    constructor() {
        super();
        this._timeType = TaskTimeType.DURATION;
        this._action = TaskAction.DEFAULT;
        this._duration = 0;
        this._interval = 0;
        this._startOffset = 0;
        this._endOffset = 0;
        this._price = [];
        this._rush = [];
        this._reward = null;
        this._adPlacement = null;
    }

    get timeType() {
        return this._timeType;
    }

    set timeType(value) {
        this._timeType = value;
    }

    get action() {
        return this._action;
    }

    set action(value) {
        this._action = value;
    }

    get duration() {
        return this._duration;
    }

    set duration(value) {
        this._duration = value;
    }

    get price() {
        return this._price;
    }

    set price(value) {
        this._price = value;
    }

    get rush() {
        return this._rush;
    }

    set rush(value) {
        this._rush = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    get interval() {
        return this._interval;
    }

    set interval(value) {
        this._interval = value;
    }

    get startOffset() {
        return this._startOffset;
    }

    set startOffset(value) {
        this._startOffset = value;
    }

    get endOffset() {
        return this._endOffset;
    }

    set endOffset(value) {
        this._endOffset = value;
    }

    get adPlacement() {
        return this._adPlacement;
    }

    set adPlacement(value) {
        this._adPlacement = value;
    }

    valid() {

        if (!TaskTimeType.is(this.timeType)) {
            return false;
        }

        if (!TaskAction.is(this.action)) {
            return false;
        }

        if (!Number.isInteger(this.duration) || this.duration < 0) {
            return false;
        }

        if (!Number.isInteger(this.interval) || this.interval < 0) {
            return false;
        }

        if (!Number.isInteger(this.startOffset) || this.startOffset < 0) {
            return false;
        }

        if (!Number.isInteger(this.endOffset) || this.endOffset < 0) {
            return false;
        }

        if (this.price && this.price.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.rush && this.rush.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.reward && !this.reward.valid()) {
            return false;
        }

        if (this.adPlacement && !RedactorUtils.getAdPlacement(this.adPlacement)) {
            return false;
        }

        return true;
    }

    empty() {
        return false;
    }

    copy() {
      return this.clone();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TaskModel());
        } else if (target instanceof TaskModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TaskModel, {
    _action: alias("action", TaskAction.schema()),
    _timeType: alias("time_type", TaskTimeType.schema()),
    _duration: alias("duration", Schema.primitive()),
    _interval: alias("interval", Schema.primitive()),
    _startOffset: alias("start_offset", Schema.primitive()),
    _endOffset: alias("end_offset", Schema.primitive()),
    _price: alias("price", list(Currency.schema())),
    _rush: alias("rush", list(Currency.schema())),
    _reward: alias("reward", RewardModel.schema()),
    _adPlacement: alias("ad_placement", Schema.primitive())
});
